import { getDefaultClient } from '../../../../client/defaultClient';
import { getWalletProviderFromWalletAccount } from '../../utils/getWalletProviderFromWalletAccount';
import type { WalletAccount } from '../../walletAccount';
import { getNetworkProviderFromNetworkId } from '../getNetworkProviderFromNetworkId';

type GetBalanceParams = {
  walletAccount: WalletAccount;
};

/**
 * Retrieves the native token balance for a wallet account.
 *
 * This function fetches the balance of the native cryptocurrency
 * (e.g., ETH, SOL, BTC, etc.) for the specified wallet account.
 *
 * @param params.walletAccount - The wallet account to get the balance for.
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns A promise that resolves to an object containing the balance as a string or null.
 */
export const getBalance = async (
  { walletAccount }: GetBalanceParams,
  client = getDefaultClient()
): Promise<{ balance: string | null }> => {
  const walletProvider = getWalletProviderFromWalletAccount(
    {
      walletAccount,
    },
    client
  );

  const { networkId } = await walletProvider.getActiveNetworkId();

  const networkProvider = getNetworkProviderFromNetworkId(
    { chain: walletProvider.chain, networkId },
    client
  );

  return networkProvider.getBalance({ address: walletAccount.address });
};
